import { Grid, Icon, IconButton, LinearProgress, Typography } from "@mui/material";
import { useDrawerStyles } from "../../_styles/drawer.styles";

export function DrawerHeader(params: {
    isFullWidth?: boolean,
    children?: React.ReactNode,
    name: string,
    isLoading?: boolean,
    onClose(): void
}) {

    return (
        <>
            <Grid sx={useDrawerStyles.header} container>
                <Grid item sx={{paddingTop: "0px"}}>
                    <Typography variant="h6">{params.name} </Typography>
                </Grid>
                <Grid item>
                    <IconButton color="inherit" onClick={params.onClose}><Icon>close</Icon></IconButton>
                </Grid>
            </Grid>

            <Grid container spacing={1} sx={{ marginBottom: "5px", height: "15px" }}>
                <Grid item xs={12}>
                    {params.isLoading && <LinearProgress />}
                </Grid>
            </Grid>
        </>
    );

}
